import { JsSettings } from "../models";
import config from "../config";
import types from "../definitions/types";
import { ajax } from "dhx-suite";

const cache: Record<string, string> = {};

export async function getLibsDefinitions(settings: JsSettings) {
    const { widgets } = settings;
    const basePath = "https://cdn.dhtmlx.com/";

    const libsPaths: [string, string][] = widgets.map(({ name, version }) => {
        if (types.hasOwnProperty(name)) {
            if (name === "gantt") {
                return [[`${version}.d.ts`, `${basePath}/${name}/${version}.d.ts?${config.generation}`]];
            }
            // @ts-ignore
            const widgetTypes = types[name][`${name}@${version}`];
            return widgetTypes && widgetTypes.paths ? widgetTypes.paths.map((p: string) => {
                return [`${widgetTypes.libName}/${p}`, `${basePath}${widgetTypes.basePath}/${p}`];
            }) : [];
        }
    }).reduce((acc, arr) => arr !== undefined ? [...acc, ...arr] : acc, []) as [string, string][];

    const libs: (readonly [string, string])[] = await Promise.all(libsPaths.map(async ([name, path]) => {
        if (cache[path]) {
            return Promise.resolve([name, cache[path]] as const);
        } else {
            try {
                const libDefinition = await ajax.get<string>(path, undefined, { responseType: "text" });
                cache[path] = libDefinition;
                return [name, cache[path]] as const;
            } catch (err) {
                return ["", ""] as const;
            }
        }
    }));

    return libs.reduce((acc, lib) => {
        if (lib[0]) {
            acc.push({ content: lib[1], filePath: lib[0] });
        }
        return acc;
    }, [] as {content: string, filePath: string}[]);
}
